import { styled } from 'styletron-react';
import { Row } from 'react-bootstrap';

export const SectionSeparator = styled(Row, {
  height: '72px'
});
